import { Navigate, useRoutes } from "react-router-dom";
import MatchedList from "./Matched/MatchedList";
import MatchCodes from "./Match/MatchCodes";
import Login from "./Login/Login";
import PrivateRoute from "../components/PrivateRoute";

export default function Router() {
  const baseRouter = {
    children: [
      { 
        path: "/", 
        element: <PrivateRoute><Navigate to="/matchcodes" replace /></PrivateRoute> 
      },
      { path: "/login", element: <Login /> },
      { 
        path: "/matchcodes", 
        element: <PrivateRoute><MatchCodes /></PrivateRoute> 
      },
      { 
        path: "/matchedlist", 
        element: <PrivateRoute><MatchedList /></PrivateRoute> 
      },
    ],
  };

  const routes = [baseRouter];

  return useRoutes(routes);
}